<template>
  <div class="controls">
    <button @click="show" class="button">
      <div class="dashicons dashicons-welcome-view-site" />
    </button>
    <div class="modal" ref="modal" v-show="shown">
      <div class="image" :class="magnified ? 'magnified' : ''" @click="toggleMagnification">
        <img :src="medium.src" />
      </div>
      <div class="scrim" @click="hide" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    shown: false,
    magnified: false
  }),
  props: {
    medium: Object
  },
  methods: {
    onKeyUp(e) {
      if (e.which === 27) {
        this.hide()
      }
    },
    show() {
      this.shown = true
      if (this.fullscreenMode) {
        this.$refs.modal.webkitRequestFullscreen()
        window.addEventListener('webkitfullscreenchange', this.fullScreenChange)
      } else {
        window.addEventListener('keyup', this.onKeyUp)
      }
    },
    hide() {
      this.shown = false
      if (this.fullscreenMode) {
        window.removeEventListener('webkitfullscreenchange', this.fullScreenChange)
      } else {
        window.removeEventListener('keyup', this.onKeyUp)
      }
    },
    fullScreenChange() {
      if (!document.webkitFullscreenElement) {
        this.hide()
      }
    },
    toggleMagnification() {
      this.magnified = !this.magnified
    },
    toggle () {
      if (!this.shown) {
        this.show()
      } else {
        this.hide()
      }
    }
  },
  computed: {
    ...mapState([
      'fullscreenMode'
    ])
  }
}
</script>

<style>

</style>